import { render, staticRenderFns } from "./template-tab.vue?vue&type=template&id=148473da&scoped=true"
import script from "./template-tab.vue?vue&type=script&lang=js"
export * from "./template-tab.vue?vue&type=script&lang=js"
import style0 from "./template-tab.vue?vue&type=style&index=0&id=148473da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148473da",
  null
  
)

export default component.exports